<app-floating-button *ngIf="repository.selectedCategory$ | async"
  [cmpModal]="MobileFiltersModalComponent"
  [isActiveFilter]="!!(repository.selectedAttributes$ | async)?.length"
></app-floating-button>

<app-breadcrumb
  *ngIf="repository.breadcrumbs$ | async as breadcrumbs"
  [title]="(repository.title$ | async) ?? ''"
  [items]="breadcrumbs"
  [hasFloatingButton]="true"
></app-breadcrumb>

<div class="section section-has-sider" *ngIf="repository.selectedCategory$ | async; else skeleton">
  <app-helix-lite-info class="section-content">
  </app-helix-lite-info>
  <div class="section-content section-sider-mobile-top grid">
    <div class="section-main min-w-128">
      <div class="grid grid-column grid-gutter-40">
        <ng-container *ngIf="repository.complexes$ | async as complexes">
          <app-catalog-section-list
            class="grid-item full-width"
            *ngIf="complexes.length"
            [title]="TypeNomenclatures.Complexes"
            [list]="complexes"
          ></app-catalog-section-list>
        </ng-container>

        <ng-container *ngIf="repository.analyses$ | async as analyses">
          <app-catalog-section-list
            class="grid-item full-width"
            *ngIf="analyses.length"
            [title]="TypeNomenclatures.Analyzes"
            [list]="analyses"
          ></app-catalog-section-list>
        </ng-container>

        <ng-container *ngIf="repository.services$ | async as services">
          <app-catalog-section-list
            class="grid-item full-width"
            *ngIf="services.length"
            [title]="TypeNomenclatures.Services"
            [list]="services"
          ></app-catalog-section-list>
        </ng-container>

        <app-catalog-list-skeleton
          *ngIf="repository.pendingLoad$ | async"
          class="grid-item full-width"
        ></app-catalog-list-skeleton>
      </div>

      <div
        class="empty mt-128"
        *ngIf="
          (repository.catalogItems$ | async)?.length === 0 &&
          !(repository.pendingLoad$ | async)
        "
      >
        Подходящих исследований не найдено — попробуйте изменить параметры
        поиска
      </div>

      <app-pagination
        class="mt-48"
        [pageSize]="PageSize"
        [total]="(repository.count$ | async) ?? 0"
        [currentPage]="repository.currentPage$ | async"
        *ngIf="!(repository.pendingLoad$ | async)"
      ></app-pagination>

      <app-catalog-detailed-info
        class="mt-48"
        *ngIf="repository.detailedInfo$ | async as detailedInfo"
        [title]="(repository.title$ | async) || ''"
        [info]="detailedInfo"
      ></app-catalog-detailed-info>
    </div>

    <div
      class="section-sider section-sider-mobile-full-screen grid-item grid-3 grid-lg-4 grid-sm-12"
    >
      <app-catalog-sider
        [attributes]="(repository.attributes$ | async) || []"
        [isDesktop]="true"
      ></app-catalog-sider>
    </div>
  </div>
</div>

<ng-template #skeleton>
  <app-skeleton></app-skeleton>
</ng-template>
